import { faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from "prop-types";
import React from "react";

const ScanBtn = ({ onScan, className, disabled, ariaLabel }) => {
  return (
    <button
      type="button"
      className={`inventory-scan-btn ${className || ''}`}
      disabled={disabled}
      aria-label={ariaLabel || 'Scan QR code'}
      onClick={onScan}
    >
      <FontAwesomeIcon icon={faQrcode} />
    </button>
  );
};

ScanBtn.propTypes = {
  onScan: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

ScanBtn.defaultProps = {
  className: "",
  disabled: false,
  ariaLabel: null,
};


export default ScanBtn;
